import type { Lang } from "./ajuda";

export const traducoesArtigo: Record<Lang, {
  centralAjuda: string;
  paginaInicial: string;
  artigo: string;
  buscarPlaceholder: string;
  buscarAriaLabel: string;
  resultadosPesquisa: string;
  artigoNaoEncontrado: string;
  artigoNaoEncontradoDesc: string;
  voltarCentral: string;
  resultadoPara: string;
  respostaIA: string;
  exemploArtigo: string;
  verFonteOriginal: string;
  atualizadoEm: string;
  ajudouTitle: string;
  ajudouDesc: string;
  ajudouSim: string;
  ajudouNao: string;
  artigosRecomendados: string;
  idioma: string;
  portuguesBrasil: string;
  site: string;
  plataforma: string;
  copyright: string;
  recommendedTitles: { title: string; href: string }[];
}> = {
  pt: {
    centralAjuda: "Central de Ajuda",
    paginaInicial: "Página Inicial",
    artigo: "Artigo",
    buscarPlaceholder: "como acessar o produto que eu comprei",
    buscarAriaLabel: "Buscar na central de ajuda",
    resultadosPesquisa: "Resultados da Pesquisa",
    artigoNaoEncontrado: "Artigo não encontrado",
    artigoNaoEncontradoDesc: "Este artigo pode ter sido removido, está indisponível ou a conexão com o servidor falhou.",
    voltarCentral: "Voltar à Central de Ajuda",
    resultadoPara: "Resultados para",
    respostaIA: "Resposta gerada por inteligência artificial. Deixe sua opinião abaixo e nos ajude a aperfeiçoar essa ferramenta.",
    exemploArtigo: "Exemplo de artigo (servidor indisponível ou artigo não encontrado). Para ver artigos reais, suba o backend e cadastre artigos na base de conhecimento.",
    verFonteOriginal: "Ver fonte original",
    atualizadoEm: "Atualizado em",
    ajudouTitle: "Essa informação te ajudou?",
    ajudouDesc: "Nos ajude a evoluir e entre em contato se precisar de mais assistência.",
    ajudouSim: "A resposta me ajudou",
    ajudouNao: "A resposta não me ajudou",
    artigosRecomendados: "Artigos recomendados",
    idioma: "Idioma",
    portuguesBrasil: "Português - Brasil",
    site: "Site",
    plataforma: "Plataforma",
    copyright: "© 2011–2026 Todos os direitos reservados.",
    recommendedTitles: [
      { title: "Meus Produtos: todas as suas compras em um único lugar!", href: "/ajuda" },
      { title: "Como acessar minha primeira compra?", href: "/ajuda" },
      { title: "Como acessar o produto que comprei?", href: "/ajuda" },
    ],
  },
  en: {
    centralAjuda: "Help Center",
    paginaInicial: "Home",
    artigo: "Article",
    buscarPlaceholder: "how to access the product I bought",
    buscarAriaLabel: "Search help center",
    resultadosPesquisa: "Search Results",
    artigoNaoEncontrado: "Article not found",
    artigoNaoEncontradoDesc: "This article may have been removed, is unavailable, or the server connection failed.",
    voltarCentral: "Back to Help Center",
    resultadoPara: "Results for",
    respostaIA: "Response generated by artificial intelligence. Leave your feedback below and help us improve this tool.",
    exemploArtigo: "Sample article (server unavailable or article not found). To see real articles, start the backend and add articles to the knowledge base.",
    verFonteOriginal: "View original source",
    atualizadoEm: "Updated on",
    ajudouTitle: "Did this information help you?",
    ajudouDesc: "Help us improve and contact us if you need more assistance.",
    ajudouSim: "The answer helped me",
    ajudouNao: "The answer did not help me",
    artigosRecomendados: "Recommended articles",
    idioma: "Language",
    portuguesBrasil: "English",
    site: "Website",
    plataforma: "Platform",
    copyright: "© 2011–2026 All rights reserved.",
    recommendedTitles: [
      { title: "My Products: all your purchases in one place!", href: "/ajuda" },
      { title: "How do I access my first purchase?", href: "/ajuda" },
      { title: "How do I access the product I bought?", href: "/ajuda" },
    ],
  },
  es: {
    centralAjuda: "Centro de Ayuda",
    paginaInicial: "Inicio",
    artigo: "Artículo",
    buscarPlaceholder: "cómo acceder al producto que compré",
    buscarAriaLabel: "Buscar en el centro de ayuda",
    resultadosPesquisa: "Resultados de búsqueda",
    artigoNaoEncontrado: "Artículo no encontrado",
    artigoNaoEncontradoDesc: "Este artículo puede haber sido eliminado, no está disponible o falló la conexión con el servidor.",
    voltarCentral: "Volver al Centro de Ayuda",
    resultadoPara: "Resultados para",
    respostaIA: "Respuesta generada por inteligencia artificial. Deja tu opinión abajo y ayúdanos a mejorar esta herramienta.",
    exemploArtigo: "Artículo de ejemplo (servidor no disponible o artículo no encontrado). Para ver artículos reales, inicia el backend y agrega artículos a la base de conocimiento.",
    verFonteOriginal: "Ver fuente original",
    atualizadoEm: "Actualizado el",
    ajudouTitle: "¿Te ayudó esta información?",
    ajudouDesc: "Ayúdanos a mejorar y contáctanos si necesitas más asistencia.",
    ajudouSim: "La respuesta me ayudó",
    ajudouNao: "La respuesta no me ayudó",
    artigosRecomendados: "Artículos recomendados",
    idioma: "Idioma",
    portuguesBrasil: "Español",
    site: "Sitio",
    plataforma: "Plataforma",
    copyright: "© 2011–2026 Todos los derechos reservados.",
    recommendedTitles: [
      { title: "Mis Productos: todas tus compras en un solo lugar!", href: "/ajuda" },
      { title: "¿Cómo accedo a mi primera compra?", href: "/ajuda" },
      { title: "¿Cómo accedo al producto que compré?", href: "/ajuda" },
    ],
  },
};

const localeByLang: Record<Lang, string> = { pt: "pt-BR", en: "en-US", es: "es-ES" };
export function getArtigoDateLocale(lang: Lang): string {
  return localeByLang[lang];
}
